module.exports = "https://cdn.thelire.com/ins/resource/icon_likes2.8b2b48a741a7a6dde65def8c4ebbce84.png";